<template>
  <layout class="terms" popupName="termsPopupKr" :isFromUserCenter="true" :hideClose="!useCloseBtn" @closePopup="closeTermsPopup">
    <template #title>아래 항목을 읽고 동의하시기 바랍니다</template>
    <template #main>
      <ul class="agree-list">
        <li
          class="agree-item j-look-detail"
          v-for="(item, index) in agreeItem"
          :key="index"
          @click="handleDetail(index)"
          :pointValue="index"
        >
          <span
            class="check j-check"
            :class="{ checked: item.isAgree }"
            @click.stop="handleAgree(index)"
            :pointValue="`${index}|${item.isAgree}`"
          ></span>
          <span class="text">
            {{ item.text }}
            <br v-if="item.subText" />
            {{ item.subText }}
          </span>
          <span class="ico" v-if="item.detail"></span>
        </li>
      </ul>
    </template>
    <template #button>
      <button class="btn j-agree" @click="agree">시작</button>
      <button class="btn j-agree-all" @click="agreeAll">
        모두 동의하고 시작
      </button>
    </template>
    <template #popup>
      <transition name="fade">
        <tip-popup v-show="showTip" :tip="tip" @close="closeTip"></tip-popup>
      </transition>
      <transition name="fade">
        <content-detail
          v-show="showDetail"
          :detail="detail"
          @close="closeDetail"
        ></content-detail>
      </transition>
    </template>
  </layout>
</template>

<script>
import {
  personalizedAdPolicyHtml,
  termDetailHtml,
  zrrglobalTermDetailHtml,
  zrrglobalUseDetailHtml,
  zrrglobalThirdDetailHtml,
  zrrglobalForeignThirdDetailHtml,
  zrrglobalOperationPolicyHtml,
  useDetailHtml,
  thirdDetailHtml,
  foreignThirdDetailHtml,
  operationPolicyHtml,
  omnikadeUseDetailHtml,
  omnikadeTermDetailHtml,
  threeSeventUseDetailHtml,
  threeSeventForeignThirdDetailHtml,
  threeSeventTermDetailHtml
} from '@components/terms/termsConfig.js';
import Layout from '@components/terms/Layout.vue';
import TipPopup from '@components/terms/TipPopup.vue';
import ContentDetail from '@components/terms/ContentDetail.vue';
import bridge from '@utiles/bridge';
import terms from '@mixins/terms/terms';
import globalConfig from '@utiles/globalConfig';
const isOmnikade = window.location.hostname.indexOf('omnikade.com') > -1;
const isThirtySevenGames = window.location.hostname.indexOf(window.atob('MzdnYW1lcy5jb20=')) > -1;

const mainHost = globalConfig.getMainHost();

const termsOfServiceKrDetail = (() => {
  if (mainHost === window.atob('enJyZ2xvYmFsLmNvbQ==')) {
    return zrrglobalTermDetailHtml;
  }
  if (mainHost === 'omnikade.com') {
    return omnikadeTermDetailHtml;
  }
  if (mainHost === window.atob('MzdnYW1lcy5jb20=')) {
    return threeSeventTermDetailHtml;
  }
  return termDetailHtml;
})();

const useOfPersonalInfoKrDetail = (() => {
  if (mainHost === window.atob('enJyZ2xvYmFsLmNvbQ==')) {
    return zrrglobalUseDetailHtml;
  }
  if (mainHost === 'omnikade.com') {
    return omnikadeUseDetailHtml;
  }
  if (mainHost === window.atob('MzdnYW1lcy5jb20=')) {
    return threeSeventUseDetailHtml;
  }
  return useDetailHtml;
})();

const thirdDetail = (() => {
  if (mainHost === window.atob('enJyZ2xvYmFsLmNvbQ==')) {
    return zrrglobalThirdDetailHtml;
  }
  return thirdDetailHtml;
})();

const shareOfPersonalInfoKrDetail = (() => {
  if (mainHost === window.atob('enJyZ2xvYmFsLmNvbQ==')) {
    return zrrglobalForeignThirdDetailHtml;
  }
  if (mainHost === window.atob('MzdnYW1lcy5jb20=')) {
    return threeSeventForeignThirdDetailHtml;
  }
  return foreignThirdDetailHtml;
})();

const operationPolicy = (() => {
  if (mainHost === window.atob('enJyZ2xvYmFsLmNvbQ==')) {
    return zrrglobalOperationPolicyHtml;
  }
  return operationPolicyHtml;
})();

export default {
  name: 'krTermsPopup',
  mixins: [terms],
  props: {
    isFromUserCenter: {
      type: Boolean,
      default: false
    },
    skin: {
      type: String,
      default: 'store'
    },
    useCloseBtn: {
      type: Boolean,
      default: true
    },
    nopadding: {
      type: Boolean,
      default: false
    },
    defaultSelect: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      agreeItem: [
        {
          require: true,
          isAgree: false,
          text: '이용약관 동의',
          subText: '',
          detail: termsOfServiceKrDetail,
          tip: "계속 이용하시려면 '이용약관 동의' 항목에 동의하세요.",
          eventType: 'termsOfServiceKr'
        },
        {
          require: true,
          isAgree: false,
          text: '개인정보 수집 및 이용 동의',
          subText: '',
          detail: useOfPersonalInfoKrDetail,
          tip: "계속 이용하시려면 '개인정보 수집 및 이용 동의' 항목에 동의하세요.",
          eventType: 'useOfPersonalInfoKr'
        },
        {
          require: true,
          isAgree: false,
          text: '개인정보 제3자 제공',
          subText: '',
          detail: thirdDetail,
          tip: "계속 이용하시려면 '개인정보 제3자 제공' 항목에 동의하세요.",
          eventType: 'dataTransferOfPersonalInfoKr'
        },
        {
          require: true,
          isAgree: false,
          text: '개인정보 국외 제3자 제공',
          subText: '',
          detail: shareOfPersonalInfoKrDetail,
          tip: "계속 이용하시려면 '개인정보 국외 제3자 제공' 항목에 동의하세요.",
          eventType: '3rdShareOfPersonalInfoKr'
        },
        {
          require: true,
          isAgree: false,
          text: '운영정책',
          subText: '',
          detail: operationPolicy,
          tip: "계속 이용하시려면 '운영정책' 항목에 동의하세요.",
          eventType: 'operationPolicyKr'
        },
        {
          require: false,
          isAgree: false,
          text: '마케팅 활용 동의(선택)',
          subText: '*비활성화하면 개인 맞춤형 광고를 위한 데이터 공유에 동의하지 않게 됩니다.',
          detail: personalizedAdPolicyHtml,
          tip: "",
          eventType: 'personalizedAdPolicyKr'
        }
      ],
      showTip: false,
      tip: '',
      showDetail: false,
      detail: ''
    };
  },
  created() {
    this.handleDetailReplace();
    if (!this.showNewTerms) {
      this.agreeItem.unshift({
        require: true,
        isAgree: false,
        text: '만 14세 이상입니다',
        subText: '',
        tip: '만 14세 미만은 이용할 수 없습니다.',
        eventType: 'ageConfirmKr'
      });
    }
    this.initSelectTerm();
  },
  mounted() {
    window?.passportv2DataLayer?.push({
      eventName: 'show_popup',
      eventValue: '', // 成功留空
      eventType: 'termsPopupKr',
      eventReason: 'passportTermsKr'
    });
  },
  methods: {
    initSelectTerm() {
      let selectTerms = [];
      // 用户中心默认选中必选
      if (this.isFromUserCenter) {
        let _termList = this.agreeItem;
        selectTerms = _termList.reduce((total, item, index) => {
          if (item.require) {
            total.push(index);
          }
          return total;
        }, []);
        // 再来判断一下可选
        let optionalArr = String(this.defaultSelect).split('');
        let requireLen = selectTerms.length;
        optionalArr.forEach((item, index) => {
          let curIndex = +index + +requireLen;
          if (!_termList[curIndex]) return;
          if (_termList[curIndex].require) return;
          // 1为选中，0为没选
          if (item == 1) {
            selectTerms.push(curIndex);
          }
        });
      }
      this.agreeItem.forEach((_item, index) => {
        if (selectTerms.includes(index)) {
          this.setItemAgreeStatus(index, true);
        }
      });
    },
    handleDetailReplace() {
      if (isOmnikade) {
        this.agreeItem.forEach(item => {
          if (item.detail) {
            item.detail = item.detail
              .replace(
                /https:\/\/www.blancozone.com\//g,
                'https://www.omnikade.com/'
              )
              .replace(/service@Blancozone.com/g, 'service@omnikade.com')
              .replace(/BLANCOZONE/g, 'OMNIKADE');
          }
        });
        return;
      }
      if (isThirtySevenGames) {
        this.agreeItem.forEach(item => {
          if (item.detail) {
            item.detail = item.detail
              .replace(
                /https:\/\/www.blancozone.com\//g,
                window.atob('aHR0cHM6Ly93d3cuMzdnYW1lcy5jb20v')
              )
              .replace(
                /https:\/\/www.domain.com\//g,
                window.atob('aHR0cHM6Ly93d3cuMzdnYW1lcy5jb20v')
              )
              .replace(/service@Blancozone.com/g, window.atob('Z2xvYmFsLnN1cHBvcnRAMzdnYW1lcy5jb20='))
              .replace(/global.support@domain.com/g, window.atob('Z2xvYmFsLnN1cHBvcnRAMzdnYW1lcy5jb20='))
              .replace(/BLANCOZONE NETWORK CO., LIMITED/g, window.atob('MzdHQU1FUw==')) // 不要改变顺序，需要先替换这个
              .replace(/BLANCOZONE/g, window.atob('MzdHQU1FUw=='));
          }
        });
        return;
      }
    },
    handleAgree(index) {
      if (this.agreeItem[index].require) {
        return;
      }
      this.setItemAgreeStatus(index, !this.agreeItem[index].isAgree);
    },
    setItemAgreeStatus(index, status) {
      this.agreeItem.splice(
        index,
        1,
        Object.assign({}, this.agreeItem[index], {
          isAgree: status
        })
      );
    },
    handleDetail(index) {
      let { detail, eventType } = this.agreeItem[index];
      if (detail) {
        this.detail = detail;
        this.showDetail = true;
        window?.passportv2DataLayer?.push({
          eventName: 'show_popup',
          eventValue: '',
          eventType: eventType,
          eventReason: 'passportTermsKr'
        });
        window.setPhoneReturnCb(true, () => {
          this.closeDetail();
        });
      }
    },
    agree() {
      window?.passportv2DataLayer?.push({
        eventName: 'click_button',
        eventValue: '',
        eventType: 'agreeBtn',
        eventReason: 'termsPopupKr'
      });
      let isAllAgree = this.agreeItem.every(item => item.isAgree || !item.require);
      if (isAllAgree) {
        this.reportAgree();
        // this.closeTermsPopup();
        return;
      }
      for (let i = 0, length = this.agreeItem.length; i < length; i++) {
        if (!this.agreeItem[i].isAgree && this.agreeItem[i].require) {
          this.tip = this.agreeItem[i].tip;
          this.showTip = true;
          window.setPhoneReturnCb(true, () => {
            this.closeTip();
          });
          break;
        }
      }
    },
    agreeAll() {
      window?.passportv2DataLayer?.push({
        eventName: 'click_button',
        eventValue: '',
        eventType: 'allAgreeBtn',
        eventReason: 'termsPopupKr'
      });
      this.setAgreeAll();
      this.reportAgree();
      // setTimeout(this.closeTermsPopup, 800);
    },
    reportAgree() {
      // 从URL获取参数
      const urlParams = new URLSearchParams(window.location.search);
      const protocolId = urlParams.get('protocolId');
      const apps = urlParams.get('apps');

      // 构建consentMode
      let consentMode = '';
      this.agreeItem.forEach((item, index) => {
        if (item.require) return;
        consentMode += item.isAgree ? '1' : '0';
      });

      // 请求接口
      if (protocolId && apps) {
        fetch(
          `https://geventsapi.${window.atob('MzdnYW1lcy5jb20=')}/protocolPopup/clickCallBack?protocolId=${protocolId}&apps=${apps}`
        )
          .then(response => response.json())
          .then(res => {
            if (+res.result === 1) {
              this.$emit('clickSubmit', consentMode);
            }
          })
          .catch(error => console.error('请求失败:', error));
      } else {
        // 如果没有protocolId和apps参数，直接执行提交
        this.$emit('clickSubmit', consentMode);
      }
    },
    setAgreeAll() {
      this.agreeItem.forEach((_item, index) =>
        this.setItemAgreeStatus(index, true)
      );
    },
    closeTermsPopup() {
      this.$emit('closePopup');
    },
    closeDetail() {
      this.showDetail = false;
      window.setPhoneReturnCb(true, () => {
        this.closeTermsPopup();
      });
    },
    closeTip() {
      this.showTip = false;
      window.setPhoneReturnCb(true, () => {
        this.closeTermsPopup();
      });
    }
  },
  components: {
    TipPopup,
    ContentDetail,
    Layout
  }
};
</script>

<style lang="scss">
@import '@assets/scss/platform-terms.scss';
</style>
<style lang="scss" scoped>
.terms {
  .agree-list {
    margin: 0px auto;
    border-top: 1px solid #ebf2f9;
    border-bottom: 1px solid #ebf2f9;
    width: 456px;
    .agree-item {
      display: flex;
      position: relative;
      align-items: center;
      margin: 20px 0;
      padding: 20px 22px;
      border: 1px solid #81acd9;
      border-radius: 15px;
      max-height: 120px;
      height: auto;
      line-height: 1.4;
      // &:last-child {
      //   margin-bottom: 0px;
      // }
      .text {
        max-width: calc(100% - 103px);
      }
    }
  }

  ::v-deep .title {
    margin-top: 10px;
    text-align: center;
    font-weight: bolder;
    font-size: 36px;
    line-height: 1.2;
  }

  ::v-deep .btn-wrap {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    width: 456px;
    gap: 30px;

    .btn {
      border-radius: 28px;
      width: 222px;
      height: 60px;
      background: #84b7ee;
      cursor: pointer;
      line-height: 60px;
      text-align: center;
      font-size: 22px;
      color: #fff;
    }
  }
}
@media screen and (orientation: landscape) {
  .terms {
    .agree-list {
      margin: 6px auto;
      width: 356px;
      .agree-item {
        margin: 3px 0;
        border-radius: 9px;
        &:last-child {
          margin-bottom: 6px;
        }
      }
    }

    ::v-deep .title {
      margin-top: 5px;
      font-size: 18px;
    }

    ::v-deep .btn-wrap {
      width: 356px;
      .btn {
        width: 156px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
      }
    }
  }
}
</style>
